import { useQuery } from "@tanstack/react-query";
import { apiUrl } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { GalleryPhotoFilterFacets } from "@shared/api";

const STALE_MS = 5 * 60 * 1000;

export function useGalleryPhotoFacets() {
  return useQuery({
    queryKey: queryKeys.galleryPhotoFacets,
    queryFn: async (): Promise<GalleryPhotoFilterFacets> => {
      const r = await fetch(apiUrl("/api/images/photos/facets"), { credentials: "include" });
      if (!r.ok) throw new Error("gallery_facets_failed");
      return r.json() as Promise<GalleryPhotoFilterFacets>;
    },
    staleTime: STALE_MS,
  });
}
